import { API } from "@/api/api";
import { makeDeleteRequest } from "@/api/fetchCalls";

const deleteRoleById = async (id: number) => {
  return (await makeDeleteRequest(
    `${API.PERMISSIONS.MEMBERSHIP_GROUPS}/${id}`,
  )) as Promise<void>;
};

export default deleteRoleById;
